import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["name", "format", "tooltip", "draggable"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file SliderDragger 滑竿拖拽的球
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useDragger } from '@tencent/glue-react-region';
import { guid } from '@tencent/glue-util-helper';
import React, { Fragment, memo, useMemo, useState } from 'react';
import { Popper } from '../Popper';
import { ViewSliderDragger } from '../../views/ViewSliderDragger';
import { ViewSliderDraggerPopover } from '../../views/ViewSliderDraggerPopover';
var Dragger = Popper.withHoverTrigger(ViewSliderDragger);
var Popover = Popper.withPopperContent(function (props) {
  var extra = Object.assign({}, props);
  delete extra.arrowStyle;
  delete extra.showArrow;
  delete extra.arrowDirection;
  delete extra.placement;
  delete extra.arrowRef;
  return React.createElement(ViewSliderDraggerPopover, _objectSpread({}, extra));
});
export var SliderDragger = memo(function (props) {
  var name = props.name,
      format = props.format,
      tooltip = props.tooltip,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      extra = _objectWithoutProperties(props, _excluded);

  var id = useMemo(function () {
    return guid();
  }, []);
  var ids = useMemo(function () {
    return [id];
  }, []);

  var _useDragger = useDragger(name, draggable),
      _useDragger2 = _slicedToArray(_useDragger, 2),
      elemRef = _useDragger2[0],
      _useDragger2$ = _useDragger2[1],
      offset = _useDragger2$.offset,
      dragging = _useDragger2$.dragging,
      precision = _useDragger2$.precision;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  return React.createElement(Fragment, null, React.createElement(Dragger, _objectSpread(_objectSpread({}, extra), {}, {
    elRef: elemRef,
    triggerId: id,
    left: offset.x
  })), React.createElement(Popover, {
    refType: "trigger",
    refId: id,
    triggerIds: ids,
    placement: "top",
    show: dragging || show,
    onVisibleChange: setShow,
    preventOverflow: false,
    arrow: true,
    getPopper: function getPopper() {
      var value = format ? format(precision.x) : precision.x;

      if (typeof tooltip === 'function') {
        return tooltip(value);
      }

      return tooltip || value;
    }
  }));
});